import { useMutation, UseMutationOptions } from 'react-query';
import { mutateRunnerMargins } from './runnerMargins';
import { TRunnerMarginsBody } from './runnerMargins.types';

export const useMutationRunnerMargins = (
  options?: UseMutationOptions<unknown, unknown, TRunnerMarginsBody>
) => useMutation((data) => mutateRunnerMargins(data), options);
